import { render } from "./Personal_Talk.vue?vue&type=template&id=3e03e595"
import script from "./Personal_Talk.vue?vue&type=script&lang=ts"
export * from "./Personal_Talk.vue?vue&type=script&lang=ts"

import "./Personal_Talk.vue?vue&type=style&index=0&id=3e03e595&lang=scss"
script.render = render

export default script